/**
 * gdpr-consent-manager-matomo-bridge.js
 * 
 * Dieser Connector horcht auf die Allow-Events des GDPR Consent Managers und sendet diese weiter an Matomo.
 * 
 * @author jjarolim
 */

export const init = () => {

    const gdprConsentManager = document.getElementById( 'gdpr-consent-manager' );

    // Wir horchen auf allowed Events des GDPR Consent Managers und schicken diese 1:1 weiter an Matomo

    gdprConsentManager.addEventListener( 'allowed', event => {
        
        window._mtm = window._mtm || [];
        window._mtm.push({
            event: 'gdpr_consent_allowed',
            'gdpr_consent_allowed': event.detail
        } );
    } )

    // Falls wir zu spät aufgerufen werden, fragen wir den Status nochmal nach

    gdprConsentManager.dispatchEvent( new Event( 'publishState' ) )

}